import { useEffect, useState } from "react";
import axios from "axios";

export default function LivePrice({ symbol = "AAPL", apiKey }) {
  const [quote, setQuote] = useState(null); // { c, d, dp }
  const [timestamp, setTimestamp] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!apiKey) return;
    setQuote(null);
    setError(null);

    const fetchPrice = async () => {
      try {
        const res = await axios.get(
          `https://finnhub.io/api/v1/quote?symbol=${symbol}&token=${apiKey}`
        );
        if (res.data && res.data.c) {
          setQuote(res.data);
          setTimestamp(new Date());
        } else {
          setError("No live data");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to fetch price");
      }
    };

    fetchPrice();
    const interval = setInterval(fetchPrice, 5000);
    return () => clearInterval(interval);
  }, [symbol, apiKey]);

  if (error) return <div className="state state--error">{error}</div>;

  if (!quote) {
    return (
      <div className="live">
        <div className="skeleton sk-line" style={{ width: 70 }} />
        <div className="skeleton" style={{ width: 150, height: 38 }} />
        <div className="skeleton sk-line" style={{ width: 120, marginTop: 8 }} />
      </div>
    );
  }

  const up = quote.d >= 0;
  return (
    <div className="live">
      <span className="live-value mono">
        {quote.c.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}
      </span>
      <span className={`live-delta mono ${up ? "up-text" : "down-text"}`}>
        {up ? "+" : ""}
        {quote.d?.toFixed(2)} ({up ? "+" : ""}
        {quote.dp?.toFixed(2)}%) today
      </span>
      <span className="live-meta">Updated {timestamp?.toLocaleTimeString()}</span>
    </div>
  );
}
